module.exports = __webpack_public_path__ + "img/ic-btn-file-upload.8056e762.svg";